import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

const lyd = new Intl.NumberFormat('en-LY', {
  style: 'currency',
  currency: 'LYD',
  minimumFractionDigits: 3,
});

export function formatLyd(amountMinor: number): string {
  return lyd.format(amountMinor / 1000);
}

export function maskMsisdn(msisdn: string | null | undefined): string {
  if (!msisdn) return '—';
  if (msisdn.length < 6) return msisdn;
  return `${msisdn.slice(0, 3)}***${msisdn.slice(-3)}`;
}
